const topics = [
  { name: '七月新番', hot: true },
  { name: '国漫崛起', hot: true },
  { name: '韩漫连载', hot: false },
  { name: '热血战斗', hot: true },
  { name: '恋爱日常', hot: false },
  { name: '异世界', hot: true },
  { name: '搞笑番', hot: false },
  { name: '悬疑推理', hot: false },
  { name: '治愈系', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3 max-w-[800px] mx-auto">
          {topics.map((item) => (
            <a
              key={item.name}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-100 border border-background-200'
              }`}
            >
              {item.hot && <i className="ri-fire-line text-xs"></i>}
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}